










































import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import ProductWineColorLabel from '~/components/pages/Product/ProductWineColorLabel.vue';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { BOTTLE_150 } from '~/constants/profilesForImage';
import { url } from '~/utils';
import { StaffReviewProduct } from '~/types/modules/staff';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
    ProductWineColorLabel,
  },
  props: {
    product: {
      type: Object as PropType<StaffReviewProduct>,
      required: true,
    },
  },
  setup(props) {
    const { IMAGE_WAVE_URL } = useRuntimeConfig();
    const imgPath = ref(`/images/flags/icon_flag-${props.product.area.code}.png`);
    const setDefaultImg = () => {
      imgPath.value = '/images/flags/icon_flag-others.png';
    };

    return { url, imgPath, setDefaultImg, BOTTLE_150, IMAGE_WAVE_URL };
  },
});
